// Deployed DEV environment (central.dev.liquorcart.com) â€” swapped in for environment.ts by the
// `dev` build configuration; the dev CodeBuild pipeline sets ANGULAR_CONFIGURATION=dev.
//
// production: TRUE for the same reason environment.qa.ts documents â€” the flag means "treat the
// credentials as real", which against a live middleware they are.
//
// The Cognito redirect URIs are not read by the sign-in flow (redirectUri() derives the origin at
// runtime, so one build is correct on every host) â€” the fields remain only because the shape is
// shared with environment.ts.
export const environment = {
    production: true,
    apiBaseUrl: 'https://api.dev.liquorcart.com',
    cognito: {
        authority: 'https://cognito-idp.us-east-2.amazonaws.com/us-east-2_Qlk5lA8SC',
        clientId: '17lmb2funen921lvbktuc90dcp',
        // Cognito domain â€” the Google federation broker (authorize/logout/token endpoints).
        cognitoDomain: 'https://dev-auth.epiapplications.io',
        redirectUri: 'https://middleware.dev.liquorcart.com',
        postLogoutRedirectUri: 'https://middleware.dev.liquorcart.com',
        // Subset of the app client's allowed OpenID Connect scopes â€” see environment.ts.
        scope: 'openid email'
    }
};
